const ordem = (a, b) => {
    if (a.nome.toLowerCase() < b.nome.toLowerCase()) {
        return -1;
    }
    if (a.nome.toLowerCase() > b.nome.toLowerCase()) {
        return 1;
    }
    return 0;
};

const ordemEmpresa = (a, b) => {
    if (a.name.toLowerCase() < b.name.toLowerCase()) {
        return -1;
    }
    if (a.name.toLowerCase() > b.name.toLowerCase()) {
        return 1;
    }
    return 0;
};

export { ordem, ordemEmpresa };
